import { JSX } from 'solid-js';
import { SharedProjectDataPanel } from '../selections/tree/shared-panel/SharedProjectDataPanel';
import {
  FileFolderItem,
  MissionDetailsSelection,
  RunDetailsSelection,
} from '@mobile-mapping/providers';

export const ProjectDataTab = (props: {
  onModelDetailsSelect?(model: FileFolderItem): void;
  onRunDetailsSelect?(run: RunDetailsSelection): void;
  onMissionDetailsSelect?(mission: MissionDetailsSelection): void;
}): JSX.Element => (
  <SharedProjectDataPanel
    onModelDetailsSelect={props.onModelDetailsSelect}
    onRunDetailsSelect={props.onRunDetailsSelect}
    onMissionDetailsSelect={props.onMissionDetailsSelect}
  />
);
